import React from "react";
import { Container, makeStyles, LinearProgress } from "@material-ui/core";

import FunnelHeader from "components/header/funnelHeader";
import StepCart from "components/funnel/steps/funnelStepCart";
import Stepper from "ui/stepper/Stepper";
import { STEPS, STEPS_NAMES } from "components/funnel/constants";
import useCart from "hooks/useCart";

export default function Panier() {
  const classes = useStyle();
  const [cart] = useCart();

  return (
    <div className={classes.container}>
      <FunnelHeader>
        <Stepper steps={STEPS} stepsNames={STEPS_NAMES} activeStep={1} />
      </FunnelHeader>
      <Container className={classes.inner} disableGutters>
        {cart ? <StepCart /> : <LinearProgress />}
      </Container>
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  container: {
    position: "relative",
  },
  inner: {
    paddingTop: theme.spacing(4),
    maxWidth: 1120,
  },
}));
